import { computed } from 'vue'

import { useBillingStore } from '@/features/billing/store'
import { PlatformType } from '@/shared/graphql/legacy/generated'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

export function useResubscribeIAP() {
  const billingStore = useBillingStore()
  const webviewStore = useWebviewStore()

  const store = computed(() =>
    billingStore.billing?.plan.platform === PlatformType.Apple
      ? 'Apple App Store'
      : 'Google Play'
  )

  const planName = computed(() => billingStore.billing?.plan.name)

  const handleGo = () => {
    webviewStore.postMessage({
      type: NativeActionsEnum.OpenStoreSettings,
    })
  }

  return { store, planName, handleGo }
}
